import { MonthlyData, IMonthlyBusinessData } from '../entities/MonthlyData';
import { MonthlyDataCalculationService } from '@/coreDomainsModule/services/monthlyDataCalculationService';
import { ArrivalStatus } from '@/coreDomainsModule/entities/arrival';
import { isIParentBusiness, IParentBusiness } from '../entities/Business';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';

/**
 * 月ごとのデータを取得する
 */
export class GetMonthlyDataService {
  /**
   * 月ごとのデータを取得する
   * @param business - 計算元の取引オブジェクト
   * @param monthDistanceArray - 月の距離の配列
   */
  static Execute(business: IBusiness, monthDistanceArray: number[]): IMonthlyBusinessData {
    const monthlyDataResult = {} as IMonthlyBusinessData;
    monthlyDataResult.businessId = business.businessId;
    monthlyDataResult.calcNearestRecommend = MonthlyDataCalculationService.calcNearestRecommend(business);
    monthDistanceArray.forEach((monthDistance) => {
      const monthlyData = {} as MonthlyData;
      monthlyData.salesResult = MonthlyDataCalculationService.calcSalesResult(business, monthDistance);
      monthlyData.announce = MonthlyDataCalculationService.calcAnnounce(business, monthDistance);
      const supplierAnnounce = MonthlyDataCalculationService.calcSupplierAnnounce(business, monthDistance);
      if (supplierAnnounce !== undefined) {
        monthlyData.supplierAnnounce = supplierAnnounce;
      }
      if ((monthDistance as number) === 0) monthlyData.nowInventory = MonthlyDataCalculationService.calcNowInventory(business);

      if (monthDistance < 0) {
        monthlyData.arrival = MonthlyDataCalculationService.calcArrival(business, monthDistance);
        monthlyData.endInventory = MonthlyDataCalculationService.calcEndInventory(business, monthDistance);
      } else {
        monthlyData.exceptedArrivalForOrderMode = MonthlyDataCalculationService.calcExpectedArrivalForOrderMode(business, monthDistance);
        monthlyData.exceptedArrivalForNormalMode = MonthlyDataCalculationService.calcExpectedArrivalForNormalMode(business, monthDistance);
        // ↓ こいつに配列を渡す
        monthlyData.exceptedEndInventory = MonthlyDataCalculationService.calcExpectedEndInventory(business, monthDistance);
        monthlyData.arrivalStatusList = MonthlyDataCalculationService.calcArrivalStatusList(business, monthDistance);
        monthlyData.deliveredArrival = MonthlyDataCalculationService.calcDeliveredArrival(business, monthDistance);
        if (monthlyData.arrivalStatusList.includes(ArrivalStatus.Unpaid) && isIParentBusiness(business))
          monthlyData.unPaidArrival = MonthlyDataCalculationService.calcUnPaidArrival(business, monthDistance);
        if (monthlyData.arrivalStatusList.includes(ArrivalStatus.ApprovalRequested) && isIParentBusiness(business))
          monthlyData.approvalRequestedArrival = MonthlyDataCalculationService.calcApprovalRequestedArrival(business, monthDistance);
        monthlyData.turnOver = MonthlyDataCalculationService.calcTurnOver(monthlyData.exceptedEndInventory, monthlyData.announce);
      }

      monthlyDataResult[monthDistance] = monthlyData;
    });
    return monthlyDataResult;
  }
}
